import React from 'react';
import PropTypes from "prop-types";
import PrimaryButton from "../PrimaryButton";
import { GREY_LIGHT} from "../../../styles/shared/colors";

const DismissButton = ({children,...props}) => <PrimaryButton color={GREY_LIGHT} {...props}>{children}</PrimaryButton>;

DismissButton.propTypes = {
    children: PropTypes.string,
    showBorder: PropTypes.bool
};

DismissButton.defaultProps = {
    children: 'NO',
    showBorder: true
};

export default DismissButton;

